import { CreateShareRequestBase } from "./create-share-request-base";
import { AudioLanguageSettings } from "./audio-language-settings";
import { SubtitleLanguageSettings } from "./subtitle-language-settings";

export class CreateShareRequest extends CreateShareRequestBase {
  episodeNb: number[] | null = null;
  objectId: number | null = 0;
  audioAuthorizedLanguagesCodes: AudioLanguageSettings[] | null = null;
  subtitleAuthorizedLanguagesCodes: SubtitleLanguageSettings[] | null = null;

  constructor(init?: Partial<CreateShareRequest>) {
    super();
    Object.assign(this, init);
  }
}
